module.exports = __webpack_public_path__ + "img/ax.6faa4d13.jpg";